import { useEffect, useState } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";

import "./App.css";
import ProtectedRoute from "./ProtectedRoute";
import { credentialsManager } from "./auth";
import { Routes } from "./constants";
import { AuthProvider } from "./hooks/useAuth";
import CheckingCredentials from "./pages/CheckingCredentials";
import Home from "./pages/Home";
import Login from "./pages/Login";
import ProductsPage from "./pages/products";

function App() {
  const [credentialsValidated, setCredentialsValidated] = useState(false);

  async function handleCredentialsAsync() {
    await credentialsManager.validateStoredCredentials();
    setCredentialsValidated(true);
  }

  useEffect(() => {
    handleCredentialsAsync();
  }, []);

  if (!credentialsValidated) {
    return <CheckingCredentials />;
  }

  return (
    <AuthProvider>
      <Router>
        <Switch>
          <ProtectedRoute exact path={Routes.HOME}>
            <Home />
          </ProtectedRoute>
          <ProtectedRoute exact path={Routes.OPERADORES}>
            <Home />
          </ProtectedRoute>
          <ProtectedRoute exact path={Routes.PRODUCTS}>
            <ProductsPage />
          </ProtectedRoute>
          <ProtectedRoute exact path={Routes.SOBRE_WALIX}>
            <Home />
          </ProtectedRoute>
          <Route path={Routes.LOGIN}>
            <Login logIn={credentialsManager.logIn} />
          </Route>
          <Redirect to={Routes.HOME} />
        </Switch>
      </Router>
    </AuthProvider>
  );
}

export default App;
